import React, { useState, useEffect, useMemo, useRef } from "react";
import {
  Row,
  Col,
  Radio,
  Table,
  Dropdown,
  Input,
  Select,
  Tooltip,
  Checkbox,
  message,
  Popover,
  Button,
  Modal,
  Upload,
} from "antd";
import infoIcon from "../../../Assets/advert_detail/infoIcon.svg";
import SearchIcon from "../../../Assets/campagin/searchIcon.svg";
import rocketIcon from "../../../Assets/advert_detail/rocket.svg";
import externalRocket from "../../../Assets/advert_detail/externalrel.png";
import exportImage from "../../../Assets/advert_detail/exportImage.svg";
import CancelIcon from "../../../Assets/cancelIcon.svg";
import FilterIcon from "../../../Assets/filter.svg";
import editIcon from "../../../Assets/campagin/edit.svg";
import downloadIcon from "../../../Assets/advert_detail/download.svg";
import deleteRed from "../../../Assets/advert_detail/delete_icon_red.svg";
import verticleDot from "../../../Assets/dots-vertical.svg";
import statusBlue from "../../../Assets/advert_detail/status.svg";
import { useNavigate, useLocation } from "react-router-dom";
import EditAddMessageModal from "./EditAddModal";
import UpgradeMembershipModal from "../UpgradeMembershipPopup";
import API_MANAGER from "../../../API";
import { downloadPDF, downloadCsv } from "../../../utils/constant";
import {
  CommonDeleteSvg,
  DownloadIcon,
  TableStatusImage,
} from "../../../Assets/campagin/sectionProgress/svgs";
import CustomPagination from "../CustomPagination";
import { ReleaseModal } from "../Popup";
import ReleaseToExternalClientModal from "../ExtrenalClient/ReleaseToExternalClientModal";
import ProfileDrawer from "../../../pages/CampaignManagement/ProfileDrawer";
import axios from "axios";
import status_image from "../../../Assets/advert_detail/status.svg";
import action_delete from "../../../Assets/advert_detail/action-delete.svg";
import shareIcon from "../../../Assets/shareIcon.svg";
import transeferImage from "../../../Assets/advert_detail/transfer.svg";
import alert_triangle from "../../../Assets/advert_detail/alert-triangle.svg";
import TransferUserModal from "../../common/AdvertDetail/TransferUserModal";
import WorkforceRequestButton, {
  CandidateTransferBadges,
} from "../../common/AdvertDetail/WorkforceRequestButton";
import Reportpopup from "../AdvertDetail/Reportpopup";

// Timer expiration constants and helpers for clearing preserved state
const TRACKER_STATE_EXPIRATION_MINUTES = 2;

// Helper function to check if stored state is expired
const isTrackerStateExpired = (timestamp) => {
  if (!timestamp) return true;
  const expirationTime = TRACKER_STATE_EXPIRATION_MINUTES * 60 * 1000; // 2 minutes in ms
  const currentTime = Date.now();
  return (currentTime - timestamp) > expirationTime;
};

// Helper function to save tracker state with timestamp
const saveTrackerStateWithTimestamp = (key, value) => {
  try {
    const stateData = {
      value: value,
      timestamp: Date.now(),
    };
    sessionStorage.setItem(key, JSON.stringify(stateData));
  } catch (error) {
    console.error("Failed to save tracker state to sessionStorage:", error);
  }
};

// Helper function to get tracker state from sessionStorage (returns null if expired)
const getTrackerStateFromStorage = (key) => {
  try {
    const storedData = sessionStorage.getItem(key);
    if (!storedData) return null;
    
    // Try to parse as JSON with timestamp
    try {
      const parsedData = JSON.parse(storedData);
      
      // If it has timestamp structure, check expiration
      if (parsedData && typeof parsedData === 'object' && parsedData.timestamp !== undefined) {
        if (isTrackerStateExpired(parsedData.timestamp)) {
          // Expired - remove from storage
          sessionStorage.removeItem(key);
          return null;
        }
        return parsedData.value;
      }
      
      // Old format without timestamp - return as is
      return parsedData;
    } catch (parseError) {
      // Not JSON - could be old format string value
      return storedData;
    }
  } catch (error) {
    console.error("Failed to get tracker state from sessionStorage:", error);
    return null;
  }
};

function Notes({
  data2,
  advertId,
  handleStatus,
  setSelectedRowData,
  handleDelete,
  setRowKey,
  getData,
  tableActionItems,
  setReloadState,
  setCandidateSelectedData,
  reloadState,
  setCurrentPage,
  currentPage,
  handleDeleteFunctionality,
  setTransferModal,
  onNotesSaved,
}) {
  const location = useLocation();
  
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [filterType, setFilterType] = useState(() => {
    const savedFilter = location?.state?.filterType;
    if (savedFilter !== undefined) {
      const normalized = Array.isArray(savedFilter) ? savedFilter : (savedFilter ? [savedFilter] : []);
      return normalized.filter(f => {
        if (!f) return false;
        if (typeof f === 'string') return f.trim() !== '';
        return true;
      });
    }
    return [];
  });

  // Restore filter from sessionStorage on mount (with 2-minute expiration)
  useEffect(() => {
    const savedFilter = getTrackerStateFromStorage(`trackerFilter_${advertId}_NOTES`);
    if (savedFilter) {
      // Filter out blank/empty values
      const filterBlankValues = (arr) => {
        if (Array.isArray(arr)) {
          return arr.filter(f => {
            if (!f) return false;
            if (typeof f === 'string') return f.trim() !== '';
            return true;
          });
        }
        return [];
      };
      
      // Ensure it's an array format like ["Yes"]
      if (Array.isArray(savedFilter)) {
        const filtered = filterBlankValues(savedFilter);
        if (filtered.length > 0) {
          setFilterType(filtered);
        } else {
          setFilterType([]);
          sessionStorage.removeItem(`trackerFilter_${advertId}_NOTES`);
        }
      } else if (savedFilter && typeof savedFilter === 'string' && savedFilter.trim() !== '') {
        setFilterType([savedFilter]);
      } else {
        setFilterType([]);
        sessionStorage.removeItem(`trackerFilter_${advertId}_NOTES`);
      }
    } else {
      setFilterType([]);
    }
  }, [advertId])
  const [messageModal, setMessageModal] = useState(false);
  const [buttonVisible, setButtonVisible] = useState(false);
  const [selectedMessage, setSelectedMessage] = useState();
  const [upgradeMembership, setUpgradeMembership] = useState(false);
  const [reportModal, setReportModal] = useState(false);
  const [reportCandidateData, setReportCandidateData] = useState(null);
  const [columns, setColumns] = useState([]);
  const [reportLoading, setReportLoading] = useState(false);
  const [ehHrLoading, setEhHrLoading] = useState(false);
  const [fullyMeets, setFullyMeets] = useState(0);
  const [partiallyMeets, setPartiallyMeets] = useState(0);
  const [doesNotMeets, setDoesNotMeets] = useState(0);
  const user = localStorage.getItem("user");
  const [openProfileDrawer, setOpenProfileDrawer] = useState(false);
  const [profileDrawerData, setProfileDrawerData] = useState(null);
  const [favoritesList, setFavoritesList] = useState([]);
  const [favoriteLoading, setFavoriteLoading] = useState({});
  const [visibleColumns, setVisibleColumns] = useState(() => {
    const saved = sessionStorage.getItem(`visibleColumns_${advertId}_NOTES`);
    return saved ? JSON.parse(saved) : null;
  });
  const [columnFilterVisible, setColumnFilterVisible] = useState(false);
  const [sortType, setSortType] = useState(null);
  const previousData2UsersRef = useRef();
  const data2UsersRef = useRef(data2?.users);
  const [dataVersion, setDataVersion] = useState(0);
  const [attachmentMap, setAttachmentMap] = useState({});
  const [acceptRejectLoading, setAcceptRejectLoading] = useState(false);
  const [proofUploadModal, setProofUploadModal] = useState(false);
  const [proofFile, setProofFile] = useState(null);
  const [uploadingProof, setUploadingProof] = useState(false);
  const [pendingAcceptData, setPendingAcceptData] = useState(null);
  const [transferUserModal, setTransferUserModal] = useState(false);
  const [candidateForForward, setCandidateForForward] = useState(null);
  
  // Refs for pagination persistence
  const prevFilterTypeRef = useRef(filterType);
  const prevSearchRef = useRef(null);
  const hasInitializedPageRef = useRef(false);
  const isResettingPageRef = useRef(false);
  const pageBeforeSearchRef = useRef(1);
  
  // Flag to track if search was explicitly cleared - persist in sessionStorage
  const [isSearchCleared, setIsSearchCleared] = useState(() => {
    return sessionStorage.getItem(`searchCleared_${advertId}`) === 'true';
  });
  
  const [search, setSearch] = useState(() => {
    // If search was cleared, don't restore anything
    if (sessionStorage.getItem(`searchCleared_${advertId}`) === 'true') {
      return null;
    }
    // Initialize from location.state or sessionStorage (with expiration)
    if (typeof location?.state === 'string') {
      const splitState = location.state.split(",");
      return splitState?.[0] || null;
    }
    const stateSearch = location?.state?.search;
    if (stateSearch !== undefined) {
      return stateSearch || null;
    }
    // Fallback to sessionStorage with expiration check
    return getTrackerStateFromStorage(`trackerSearch_${advertId}`) || null;
  });
  
  // Initialize prevSearchRef only once (not on every render)
  if (!hasInitializedPageRef.current) {
    prevSearchRef.current = search;
  }

  // Update ref when data2.users changes (but only if it's valid data)
  // This prevents clearing data when data2 is temporarily empty during refetch
  useEffect(() => {
    if (data2?.users && Array.isArray(data2.users) && data2.users.length > 0) {
      data2UsersRef.current = data2.users;
      previousData2UsersRef.current = data2.users;
      // Increment version to trigger useMemo recalculation
      setDataVersion(prev => prev + 1);
    }
  }, [data2?.users]);

  // Use useMemo to compute filtered data instead of useEffect to avoid race conditions
  // This must be after search and filterType are declared
  const data = useMemo(() => {
    // Use ref data which is more stable and doesn't change during refetch
    const sourceData = data2UsersRef.current || [];
    
    // If we have no data at all, return empty array
    if (!sourceData || sourceData.length === 0) {
      return [];
    }

    let dataToFilter = [...sourceData]; // Start with all data

    // STEP 1: Apply sorting if exists
    if (sortType === "az") {
      dataToFilter = dataToFilter.sort(function (a, b) {
        if (a?.profileId?.name < b?.profileId?.name) {
          return -1;
        }
        if (a?.profileId?.name > b?.profileId?.name) {
          return 1;
        }
        return 0;
      });
    } else if (sortType === "za") {
      dataToFilter = dataToFilter.sort(function (a, b) {
        if (a?.profileId?.name < b?.profileId?.name) {
          return 1;
        }
        if (a?.profileId?.name > b?.profileId?.name) {
          return -1;
        }
        return 0;
      });
    }

    // STEP 2: Apply search filter (if exists)
    if (search && search.trim() !== '') {
      dataToFilter = dataToFilter.filter(
        (value) =>
          value?.profileId?.name
            .toUpperCase()
            .includes(search.toUpperCase())
      );
    }

    // STEP 3: Apply category filter (if exists)
    if (filterType && Array.isArray(filterType) && filterType.length > 0) {
      const finalFiltered = filterType.flatMap((f) =>
        dataToFilter.filter((v) => v.overAllStatus === f)
      );
      return finalFiltered;
    } else {
      // No category filter, show all data (after search filter if any)
      return dataToFilter;
    }
  }, [filterType, search, sortType, dataVersion]);

  // Initialize currentPage from sessionStorage or location.state on mount
  useEffect(() => {
    if (!hasInitializedPageRef.current) {
      // Initialize refs with current values
      prevFilterTypeRef.current = filterType;
      prevSearchRef.current = search;
      
      // Restore current page from sessionStorage (if not in location.state)
      // Only restore if location.state doesn't explicitly provide a page
      if (location?.state?.currentPage === undefined) {
        const savedPage = sessionStorage.getItem(`trackerCurrentPage_${advertId}_NOTES`);
        if (savedPage && savedPage !== 'null' && savedPage !== 'undefined') {
          const pageNum = parseInt(savedPage, 10);
          if (!isNaN(pageNum) && pageNum > 0) {
            setCurrentPage(pageNum);
          }
        }
      } else if (location?.state?.currentPage !== undefined) {
        // If location.state provides a page, use it
        const pageNum = parseInt(location.state.currentPage, 10);
        if (!isNaN(pageNum) && pageNum > 0) {
          setCurrentPage(pageNum);
          sessionStorage.setItem(`trackerCurrentPage_${advertId}_NOTES`, String(pageNum));
        }
      }
      
      hasInitializedPageRef.current = true;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [advertId]); // Only run on mount or when advertId changes - intentionally excluding currentPage and setCurrentPage

  // Store current page in sessionStorage when it changes (after initialization)
  useEffect(() => {
    if (!hasInitializedPageRef.current) {
      return;
    }
    
    // Only store if we're not in the middle of a reset
    if (!isResettingPageRef.current && currentPage && currentPage > 0) {
      sessionStorage.setItem(`trackerCurrentPage_${advertId}_NOTES`, String(currentPage));
    }
    
    // Clear the reset flag after a short delay to allow the store to complete
    if (isResettingPageRef.current) {
      setTimeout(() => {
        isResettingPageRef.current = false;
      }, 0);
    }
  }, [currentPage, advertId]);

  // Reset currentPage to 1 when filterType or search actually changes (not on initial mount)
  useEffect(() => {
    if (!hasInitializedPageRef.current) {
      return;
    }
    
    // Check if filter or search actually changed (compare with previous values stored in refs)
    const currentFilterStr = JSON.stringify(filterType);
    const prevFilterStr = JSON.stringify(prevFilterTypeRef.current);
    const filterChanged = currentFilterStr !== prevFilterStr;
    const searchChanged = prevSearchRef.current !== search;
    
    // Only reset if there was an actual change (not initial mount)
    if (filterChanged || searchChanged) {
      isResettingPageRef.current = true;
      
      const wasSearching = prevSearchRef.current && String(prevSearchRef.current).trim() !== '';
      const isNowEmpty = !search || String(search).trim() === '';
      const isSearchBeingCleared = searchChanged && wasSearching && isNowEmpty;
      
      prevFilterTypeRef.current = filterType;
      prevSearchRef.current = search;
      
      if (isSearchBeingCleared && pageBeforeSearchRef.current) {
        const restoredPage = pageBeforeSearchRef.current;
        pageBeforeSearchRef.current = null;
        setCurrentPage(restoredPage);
        sessionStorage.setItem(`trackerCurrentPage_${advertId}_NOTES`, restoredPage.toString());
      } else {
        setCurrentPage(1);
        sessionStorage.setItem(`trackerCurrentPage_${advertId}_NOTES`, '1');
      }
    } else {
      // Update refs even if no change (to keep them in sync)
      prevFilterTypeRef.current = filterType;
      prevSearchRef.current = search;
    }
  }, [filterType, search, advertId]); // Removed setCurrentPage from dependencies

  // Handle column visibility toggle
  const handleColumnVisibilityToggle = (dataIndex) => {
    const newVisibleColumns = visibleColumns?.includes(dataIndex)
      ? visibleColumns.filter(col => col !== dataIndex)
      : [...(visibleColumns || []), dataIndex];
    
    setVisibleColumns(newVisibleColumns);
    sessionStorage.setItem(`visibleColumns_${advertId}_NOTES`, JSON.stringify(newVisibleColumns));
  };

  // Initialize visible columns for Notes columns
  useEffect(() => {
    if (visibleColumns === null) {
      const defaultColumns = [];
      if (user === "Root" || user === "Admin" || user === "Account") {
        defaultColumns.push("notes_comments");
      }
      if (user === "Root" || user === "Admin" || user === "Account" || user === "Associate") {
        defaultColumns.push("notes_comments_associate");
      }
      if (defaultColumns.length > 0) {
        setVisibleColumns(defaultColumns);
        sessionStorage.setItem(`visibleColumns_${advertId}_NOTES`, JSON.stringify(defaultColumns));
      }
    }
  }, [user, advertId, visibleColumns]);

  const dataperpage = 10;

  const paginatedData = data?.slice(
    (currentPage - 1) * dataperpage,
    currentPage * dataperpage
  );

  const navigate = useNavigate();

  const [releaseModal, setreleaseModal] = useState(false);
  // const [reloadState, setReloadState] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const bulkassign = async () => {
    setLoading(true);
    const data = {
      value: true,
      applicationIds: selectedRowKeys,
    };
    try {
      const response = await API_MANAGER.bulkRelease(data);
      message.success("Application successfully released.");
    } catch (error) {
      message.error("Something went wrong. Please try again.");
    }
    setReloadState(!reloadState);
    setreleaseModal(false);
    setLoading(false);
  };

  const handelAssign = () => {
    setreleaseModal(true);
  };

  const ehHrReport = async () => {
    setEhHrLoading(true);
    try {
      const response = await API_MANAGER.ehHrReport({ advertId });
      downloadCsv(response?.data, `CSV - ${advertId}`);
      setEhHrLoading(false);
    } catch (error) {
      setEhHrLoading(false);
      message.error(
        error?.response?.data?.message ||
          "Something went wrong. Please try again."
      );
    }
  };
  const handleReleaseClick = () => {
    setModalVisible(true);
  };

  const handleModalClose = () => {
    setModalVisible(false);
  };

  const handleNextStep = (result) => {
    console.log("Release result:", result);
    // Refresh the data after successful release
    getData();
    setModalVisible(false);
  };

  const userType = localStorage.getItem("user");

  const handleAcceptReject = async (actionType, rawData) => {
    if (acceptRejectLoading) return;

    const currentUserId = localStorage.getItem("userID");
    const candidateUserId = rawData?.profileId?.userId?._id || rawData?.profileId?.userId?.id;
    const isCurrentUser = currentUserId && candidateUserId && currentUserId === candidateUserId;

    let isApproved;
    if (actionType === "accept") {
      isApproved = rawData?.isApproved === "accepted" ? "unaccept" : "accepted";
      
      // If accepting (not unaccepting)
      if (isApproved === "accepted") {
        // If user is Associate: proceed without upload (proof not required for Associates)
        if (userType === "Associate") {
          await proceedWithAcceptReject(isApproved, rawData);
          return;
        }
        // If candidate is current user: cannot accept own application
        if (isCurrentUser) {
          message.warning("You cannot accept your own application.");
          return;
        }
        // For all other users (non-Associate): proof is required - show upload modal
        setPendingAcceptData({ actionType, rawData, isApproved });
        setProofUploadModal(true);
        return;
      }
      // If unaccepting
      else if (isApproved === "unaccept") {
        // If candidate is current user: cannot unaccept own application
        if (isCurrentUser) {
          message.warning("You cannot unaccept your own application.");
          return;
        }
        // Unaccepting doesn't require proof - proceed directly
        await proceedWithAcceptReject(isApproved, rawData, "");
        return;
      }
    } else if (actionType === "reject") {
      isApproved = rawData?.isApproved === "rejected" ? "unreject" : "rejected";
      
      // If rejecting (not unrejecting)
      if (isApproved === "rejected") {
        // If user is Associate: proceed without upload (proof not required for Associates)
        if (userType === "Associate") {
          await proceedWithAcceptReject(isApproved, rawData);
          return;
        }
        // If candidate is current user: cannot reject own application
        if (isCurrentUser) {
          message.warning("You cannot reject your own application.");
          return;
        }
        // For all other users (non-Associate): proof is required - show upload modal
        setPendingAcceptData({ actionType, rawData, isApproved });
        setProofUploadModal(true);
        return;
      }
      // If unrejecting
      else if (isApproved === "unreject") {
        // If user is Associate: proceed without upload (proof not required for Associates)
        if (userType === "Associate") {
          await proceedWithAcceptReject(isApproved, rawData);
          return;
        }
        // If candidate is current user: cannot unreject own application
        if (isCurrentUser) {
          message.warning("You cannot unreject your own application.");
          return;
        }
        // For all other users (non-Associate): proof is required - show upload modal
        setPendingAcceptData({ actionType, rawData, isApproved });
        setProofUploadModal(true);
        return;
      }
    }

    // Fallback: proceed directly without proof
    await proceedWithAcceptReject(isApproved, rawData);
  };

  const proceedWithAcceptReject = async (isApproved, rawData, attachmentUrl = null) => {
    if (acceptRejectLoading) return;

    setAcceptRejectLoading(true);

    try {
      const payload = { isApproved };
      if (attachmentUrl !== null && attachmentUrl !== undefined) {
        payload.attachment = attachmentUrl;
      }

      await API_MANAGER.acceptRejectCandidate(
        payload,
        rawData?.appliedJob
      );

      message.success(
        `Candidate ${
          isApproved === "accepted"
            ? "accepted"
            : isApproved === "rejected"
            ? "rejected"
            : isApproved === "unaccept"
            ? "unaccepted"
            : isApproved === "unreject"
            ? "unrejected"
            : "marked as Pending"
        } successfully.`
      );

      // Update attachment map immediately if attachment was uploaded
      if (attachmentUrl && rawData?.appliedJob) {
        setAttachmentMap(prev => ({
          ...prev,
          [rawData.appliedJob]: attachmentUrl
        }));
      } else if (!attachmentUrl && rawData?.appliedJob) {
        // Remove attachment if unaccepting/unrejecting
        setAttachmentMap(prev => {
          const newMap = { ...prev };
          delete newMap[rawData.appliedJob];
          return newMap;
        });
      }

      getData();
      
      setProofUploadModal(false);
      setProofFile(null);
      setPendingAcceptData(null);
    } catch (error) {
      message.error(
        error?.response?.data?.message?.message ||
          "Something went wrong. Please try again."
      );
    } finally {
      setAcceptRejectLoading(false);
      setUploadingProof(false);
    }
  };

  const handleProofFileChange = (info) => {
    if (info.fileList.length > 0) {
      const file = info.fileList[info.fileList.length - 1];
      if (file.originFileObj) {
        setProofFile(file.originFileObj);
      } else if (file.status === 'removed') {
        setProofFile(null);
      }
    } else {
      setProofFile(null);
    }
  };

  const handleProofUpload = async () => {
    if (!proofFile) {
      message.warning("Please upload a proof document.");
      return;
    }

    setUploadingProof(true);

    try {
      // Step 1: Get file extension and type
      const fileExtension = proofFile.type?.split("/")[1] || "pdf";
      const contentType = proofFile.type || "application/pdf";

      // Step 2: Call file upload API to get upload URL
      const uploadData = {
        extension: fileExtension,
        type: "DOCUMENT",
        contentType: contentType,
      };

      const uploadResponse = await API_MANAGER.fileUpload(uploadData);
      const uploadUrl = uploadResponse?.data?.data?.url;
      const fileKey = uploadResponse?.data?.data?.key;

      if (!uploadUrl || !fileKey) {
        throw new Error("Failed to get upload URL");
      }

      // Step 3: Upload file to the URL
      await axios.put(uploadUrl, proofFile, {
        headers: {
          "Content-Type": contentType,
        },
      });

      // Step 4: Proceed with accept action using the file key/URL as string
      // Send fileKey (or the full URL) as attachment string in the payload
      await proceedWithAcceptReject(
        pendingAcceptData?.isApproved,
        pendingAcceptData?.rawData,
        fileKey
      );
    } catch (error) {
      setUploadingProof(false);
      message.error(
        error?.response?.data?.message ||
          "Failed to upload proof. Please try again."
      );
    }
  };

  const hasSelected = selectedRowKeys.length > 0;

  const handleViewMore = (rawData, type) => {
    setSelectedMessage({ ...rawData, ["type"]: type });
    setMessageModal(true);
    // setButtonVisible(false);
  };
  const handleEditMessage = (row, type) => {
    setSelectedMessage({ ...row, ["type"]: type });
    setMessageModal(true);
    setButtonVisible(true);
  };
  const handleSorting = (e) => {
    setSortType(e);
  };
  const items = [
    {
      key: "1",
      label: (
        <Radio.Group
          className="dropDown_radio_group"
          onChange={(e) => handleSorting(e?.target?.value)}
        >
          <Row className="filter_item_row">
            <Col span={24}>
              <Radio value={"az"}>Sort by A-Z</Radio>
            </Col>
          </Row>
          <Row className="filter_item_row">
            <Col span={24}>
              <Radio value={"za"}>Sort by Z-A</Radio>
            </Col>
          </Row>
        </Radio.Group>
      ),
    },
  ];
  const handleBulkAcceptRejectCandidate = async () => {
    try {
      const params = {
        isApproved: "accepted",
        ajIds: [...selectedRowKeys],
      };
      await API_MANAGER.bulkAcceptRejectCandidate(params);
      message.success("Application successfully accepted.");
      getData();
    } catch (error) {
      message.error("Something went wrong. Please try again.");
    }
  };

  const checkFavoriteStatus = async () => {
    try {
      const response = await API_MANAGER.getAllFavourites();
      const favorites = response?.data?.data || [];
      // Force state update to trigger re-render - create new array reference
      setFavoritesList(prev => {
        const newList = [...favorites];
        return newList;
      });
    } catch (error) {
      console.error("Error checking favorite status:", error);
      // Don't clear the list on error, keep the previous state
    }
  };

  const isFavorite = (candidateId) => {
    if (!candidateId || !favoritesList || favoritesList.length === 0) return false;
    const candidateIdStr = String(candidateId);
    const isFav = favoritesList.some(fav => {
      if (!fav || !fav.candidateId) return false;
      const favCandidateId = fav.candidateId._id || fav.candidateId.id || (typeof fav.candidateId === 'string' ? fav.candidateId : null);
      if (!favCandidateId) return false;
      return String(favCandidateId) === candidateIdStr;
    });
    return isFav;
  };

  const toggleFavorite = async (candidateId, e) => {
    if (e) {
      e.stopPropagation();
    }
    
    if (!candidateId) {
      console.warn("No candidate ID provided to toggleFavorite");
      return;
    }
    
    const candidateIdStr = String(candidateId);
    
    // Prevent multiple clicks while loading
    if (favoriteLoading[candidateIdStr]) {
      return;
    }
    
    setFavoriteLoading(prev => ({ ...prev, [candidateIdStr]: true }));
    
    const currentlyFavorite = isFavorite(candidateId);
    
    try {
      if (currentlyFavorite) {
        // Find the favorite entry to get its ID
        const favoriteEntry = favoritesList.find(fav => {
          if (!fav || !fav.candidateId) return false;
          const favCandidateId = fav.candidateId._id || fav.candidateId.id || (typeof fav.candidateId === 'string' ? fav.candidateId : null);
          if (!favCandidateId) return false;
          return String(favCandidateId) === candidateIdStr;
        });
        
        if (favoriteEntry?._id) {
          await API_MANAGER.removeFavourite(favoriteEntry?.candidateId?._id);
        } else if (favoriteEntry?.id) {
          await API_MANAGER.removeFavourite(favoriteEntry?.candidateId?._id);
        } else {
          message.error("Could not find favorite entry ID. Please try again.");
          setFavoriteLoading(prev => ({ ...prev, [candidateIdStr]: false }));
          return;
        }
      } else {
        await API_MANAGER.addFavourite({ candidateId: candidateId });
      }
      
      // Always refresh favorites list after toggle to update UI immediately
      await checkFavoriteStatus();
    } catch (error) {
      console.error("Error toggling favorite:", error);
      const errMsg = error?.response?.data?.message;
      message.error(typeof errMsg === 'string' ? errMsg : (errMsg?.message || "Failed to update favorite status."));
      // Refresh on error too
      await checkFavoriteStatus();
    } finally {
      // Always clear loading state
      setFavoriteLoading(prev => {
        const updated = { ...prev };
        delete updated[candidateIdStr];
        return updated;
      });
    }
  };

  useEffect(() => {
    if (data2?.users && data2.users.length > 0) {
      checkFavoriteStatus();
    }
  }, [data2?.users]);

  // Fetch attachment data from the additional API
  useEffect(() => {
    const fetchAttachmentData = async () => {
      if (!advertId) return;
      
      try {
        const params = {
          page: 1,
          limit: 1000,
          sort: '-createdAt',
        };
        const response = await API_MANAGER.getAdvertCandidatesDetail(advertId, params);
        const candidates = response?.data?.data?.result || [];
        
        // Create a map of appliedJob ID to attachment
        const attachmentMapping = {};
        candidates.forEach((candidate) => {
          if (candidate?._id && candidate?.attachment) {
            attachmentMapping[candidate._id] = candidate.attachment;
          }
        });
        
        setAttachmentMap(attachmentMapping);
      } catch (error) {
        console.error("Error fetching attachment data:", error);
      }
    };

    fetchAttachmentData();
  }, [advertId, reloadState]);
  useEffect(() => {
    if (data2?.users?.length > 0) {
      let tempFullyMeet = 0;
      let tempDoesNotMeet = 0;
      let tempPartiallyMeet = 0;
      data2?.users?.map((item) => {
        if (item?.overAllStatus === "Yes") {
          tempFullyMeet = tempFullyMeet + 1;
        } else if (item?.overAllStatus === "No") {
          tempDoesNotMeet = tempDoesNotMeet + 1;
        } else if (item?.overAllStatus === "Warning") {
          tempPartiallyMeet = tempPartiallyMeet + 1;
        }
      });
      setFullyMeets(tempFullyMeet);
      setDoesNotMeets(tempDoesNotMeet);
      setPartiallyMeets(tempPartiallyMeet);
    }
    let temp = [
      {
        title: (
          <Row
            gutter={16}
            align={"middle"}
            // justify={"space-between"}
            style={{ flexFlow: "nowrap" }}
          >
            <Col className="table-heading-sm">Name</Col>
            <Col>
              <Dropdown
                menu={{ items }}
                overlayClassName="notificationFilterDropdown"
              >
                <img
                  src={FilterIcon}
                  alt="filter"
                  className="table-heading-sm"
                />
              </Dropdown>
            </Col>
          </Row>
        ),
        width: 250,
        fixed: "left",
        dataIndex: "name",
        render: (item, row) => {
          // Get attachment from the map using appliedJob ID
          const attachment = attachmentMap[row?.appliedJob] || row?.attachment;
          
          const rocketIconElement = row?.isReleased ? (
            <Tooltip title="Released to client" placement="bottom">
              <img
                src={rocketIcon}
                style={{
                  height: "22px",
                  padding: "3px",
                  borderRadius: "8px",
                  background: "#EBEEF7",
                }}
              />
            </Tooltip>
          ) : null;

          const nameSpan = (
            <span
              className="cursor-pointer"
              onClick={() => {
                setProfileDrawerData(row);
                setOpenProfileDrawer(true);
              }}
              style={{ minWidth: 0, wordBreak: "break-word" }}
            >
              {row?.isApproved === "accepted" ? (
                <span className="approvedStyle">
                  <span>{row?.profileId?.name}</span>
                </span>
              ) : row?.isApproved === "rejected" ? (
                <span>
                  <strike className="rejectStyleClass">
                    {row?.profileId?.name}
                  </strike>
                </span>
              ) : (
                <span>{row?.profileId?.name}</span>
              )}
            </span>
          );
          
          return (
          <div style={{ display: "flex", alignItems: "center", gap: "8px", width: "100%", minWidth: 0 }}>
            {userType !== "Associate" && (
            <Tooltip 
              title={isFavorite(row?.profileId?._id) ? "Remove from favourite" : "Click to mark as favourite"} 
              placement="bottom"
              destroyTooltipOnHide={true}
              mouseEnterDelay={0.1}
            >
              <div
                onClick={(e) => {
                  e.stopPropagation();
                  const candidateId = row?.profileId?._id;
                  if (candidateId) {
                    toggleFavorite(candidateId, e);
                  }
                }}
                onMouseEnter={(e) => {
                  e.stopPropagation();
                }}
                onMouseLeave={(e) => {
                  e.stopPropagation();
                }}
                style={{
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "20px",
                  height: "20px",
                  flexShrink: 0,
                  opacity: favoriteLoading[String(row?.profileId?._id || '')] ? 0.6 : 1,
                  pointerEvents: favoriteLoading[String(row?.profileId?._id || '')] ? "none" : "auto",
                }}
              >
                {isFavorite(row?.profileId?._id) ? (
                  <div
                    style={{
                      width: "18px",
                      height: "18px",
                      borderRadius: "50%",
                      backgroundColor: "#facc15",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <svg
                      width="12"
                      height="12"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"
                        fill="white"
                      />
                    </svg>
                  </div>
                ) : (
                  <div
                    style={{
                      width: "18px",
                      height: "18px",
                      borderRadius: "50%",
                      border: "1.5px solid #666",
                      backgroundColor: "white",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <svg
                      width="12"
                      height="12"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"
                        stroke="#666"
                        strokeWidth="1.5"
                        fill="none"
                      />
                    </svg>
                  </div>
                )}
              </div>
            </Tooltip>
            )}
            <Tooltip
              title={
                row?.hardReview || row?.progress?.length > 0 ? (
                  <div>
                    <span>Contact Details</span>
                    {row?.profileId?.phoneNumber && (
                      <Row gutter={8} align={"middle"}>
                        <Col>
                          <svg
                            width="8"
                            height="8"
                            viewBox="0 0 8 8"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <circle cx="4" cy="4" r="4" fill="#31B948" />
                          </svg>
                        </Col>

                        <Col>
                          <svg
                            width="18"
                            height="18"
                            viewBox="0 0 18 18"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M6.28325 6.63806C6.80525 7.72528 7.51684 8.74426 8.41803 9.64544C9.31921 10.5466 10.3382 11.2582 11.4254 11.7802C11.5189 11.8251 11.5657 11.8476 11.6249 11.8648C11.8351 11.9261 12.0933 11.8821 12.2714 11.7546C12.3215 11.7187 12.3644 11.6758 12.4501 11.5901C12.7123 11.3279 12.8434 11.1968 12.9752 11.1111C13.4724 10.7878 14.1133 10.7878 14.6105 11.1111C14.7423 11.1968 14.8734 11.3279 15.1356 11.5901L15.2818 11.7362C15.6804 12.1348 15.8797 12.3341 15.9879 12.5481C16.2032 12.9738 16.2032 13.4765 15.9879 13.9022C15.8797 14.1162 15.6804 14.3155 15.2818 14.7141L15.1636 14.8323C14.7664 15.2295 14.5677 15.4281 14.2977 15.5798C13.9981 15.7482 13.5327 15.8692 13.1891 15.8681C12.8793 15.8672 12.6677 15.8071 12.2443 15.687C9.9693 15.0413 7.82253 13.8229 6.03154 12.0319C4.24056 10.2409 3.0222 8.09417 2.37647 5.81912C2.25632 5.39579 2.19624 5.18412 2.19532 4.87441C2.1943 4.53074 2.31532 4.06538 2.48363 3.76575C2.63532 3.49572 2.83393 3.29711 3.23114 2.8999L3.34937 2.78167C3.74795 2.38309 3.94724 2.1838 4.16128 2.07554C4.58695 1.86024 5.08965 1.86024 5.51532 2.07554C5.72936 2.1838 5.92865 2.38309 6.32723 2.78167L6.47338 2.92782C6.73559 3.19003 6.86669 3.32113 6.9524 3.45296C7.27565 3.95013 7.27565 4.59107 6.9524 5.08823C6.86669 5.22007 6.73559 5.35117 6.47338 5.61337C6.38765 5.69911 6.34478 5.74198 6.3089 5.79208C6.18139 5.97016 6.13736 6.22835 6.19866 6.43862C6.2159 6.49779 6.23835 6.54454 6.28325 6.63806Z"
                              stroke="white"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </Col>
                        <Col>{"0" + row?.profileId?.phoneNumber}</Col>
                      </Row>
                    )}
                    {row?.profileId?.userId?.email && (
                      <Row gutter={8} align={"middle"}>
                        <Col>
                          <svg
                            width="8"
                            height="8"
                            viewBox="0 0 8 8"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <circle cx="4" cy="4" r="4" fill="#31B948" />
                          </svg>
                        </Col>
                        <Col>
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M1.66797 5.83594L8.47207 10.5988C9.02304 10.9845 9.29853 11.1773 9.59819 11.252C9.86288 11.318 10.1397 11.318 10.4044 11.252C10.7041 11.1773 10.9796 10.9845 11.5305 10.5988L18.3346 5.83594M5.66797 16.6693H14.3346C15.7348 16.6693 16.4348 16.6693 16.9696 16.3968C17.44 16.1571 17.8225 15.7747 18.0621 15.3042C18.3346 14.7695 18.3346 14.0694 18.3346 12.6693V7.33594C18.3346 5.93581 18.3346 5.23574 18.0621 4.70096C17.8225 4.23056 17.44 3.8481 16.9696 3.60842C16.4348 3.33594 15.7348 3.33594 14.3346 3.33594H5.66797C4.26784 3.33594 3.56777 3.33594 3.03299 3.60842C2.56259 3.8481 2.18014 4.23056 1.94045 4.70096C1.66797 5.23574 1.66797 5.93581 1.66797 7.33594V12.6693C1.66797 14.0694 1.66797 14.7695 1.94045 15.3042C2.18014 15.7747 2.56259 16.1571 3.03299 16.3968C3.56777 16.6693 4.26784 16.6693 5.66797 16.6693Z"
                              stroke="white"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </Col>
                        <Col>{row?.profileId?.userId?.email}</Col>
                      </Row>
                    )}
                  </div>
                ) : null
              }
              destroyTooltipOnHide={true}
            >
              {nameSpan}
            </Tooltip>
            <div style={{ display: "flex", alignItems: "center", gap: "8px", marginLeft: "auto", flexShrink: 0 }}>
            {user !== "Associate" && (
              <CandidateTransferBadges row={row} advertId={advertId} />
            )}
              {rocketIconElement}
              {attachment && (
                <Tooltip title="Proof of approval">
                  <Button
                    type="default"
                    shape="square"
                    size="small"
                    onClick={async (e) => {
                      e.stopPropagation();
                      try {
                        if (!attachment) return;
                        
                        // If attachment is already a full URL, use it directly
                        if (attachment.startsWith('http')) {
                          window.open(attachment, '_blank');
                          return;
                        }
                        
                        // The attachment field contains the file key from fileUpload API
                        // Construct S3 URL: https://dev-documents-cinchy.s3.ap-southeast-2.amazonaws.com/DOCUMENT/{fileKey}
                        const fileKey = attachment;
                        
                        // Remove DOCUMENT/ prefix if already present in the key
                        let cleanKey = fileKey;
                        if (fileKey.startsWith('DOCUMENT/')) {
                          cleanKey = fileKey.replace('DOCUMENT/', '');
                        }
                        
                        // Construct the S3 URL
                        const attachmentUrl = `https://dev-documents-cinchy.s3.ap-southeast-2.amazonaws.com/DOCUMENT/${cleanKey}`;
                        window.open(attachmentUrl, '_blank');
                      } catch (error) {
                        message.error("Failed to open document. Please try again.");
                      }
                    }}
                    style={{
                      width: "24px",
                      height: "24px",
                      padding: 0,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                    }}
                  >
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect
                        x="2"
                        y="2"
                        width="12"
                        height="12"
                        rx="1"
                        stroke="#1638B1"
                        strokeWidth="1.5"
                        fill="none"
                      />
                      <path
                        d="M6 10L10 6M10 6H7.33333M10 6V8.66667"
                        stroke="#1638B1"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </Button>
                </Tooltip>
              )}
            </div>
          </div>
          );
        },
      },
    ];
    if (user === "Root" || user === "Admin" || user === "Account") {
      temp = [
        ...temp,
        {
          title: (
            <Row align={"middle"} gutter={8}>
              <Col className="table-heading-sm">
                Notes/Comments - Internal User
              </Col>
            </Row>
          ),
          dataIndex: "notes_comments",
          width: "40%",
          render: (item, row) => (
            <>
              <Row className="leave_a_comment_row" gutter={10}>
                <Col span={22}>
                  <span>
                    {row?.notes?.internalUser &&
                    row?.notes?.internalUser?.length > 50 ? (
                      <span className="all_item_content all_item_content-sm">
                        {row?.notes?.internalUser?.substring(0, 120)} {" ..."}
                        <span
                          className="view_more_link cursor_pointer"
                          onClick={() => handleEditMessage(row, "internalUser")}
                        >
                          View More
                        </span>
                      </span>
                    ) : (
                      <>{row?.notes?.internalUser}</>
                    )}
                    {!row?.notes?.internalUser && (
                      <span className="leave_comment">Leave a comment</span>
                    )}
                  </span>
                </Col>
                {(user === "Root" ||
                  user === "Admin" ||
                  user === "Account") && (
                  <Col
                    span={1}
                    onClick={() => handleEditMessage(row, "internalUser")}
                  >
                    <img src={editIcon} alt="edit" className="cursor_pointer" />
                  </Col>
                )}
              </Row>
            </>
          ),
        },
      ];
    }
    if (
      user === "Root" ||
      user === "Admin" ||
      user === "Account" ||
      user === "Associate"
    ) {
      temp = [
        ...temp,
        {
          title: (
            <Row align={"middle"} gutter={8}>
              <Col className="table-heading-sm">
                Notes/Comments - Association User
              </Col>
            </Row>
          ),
          dataIndex: "notes_comments_associate",
          width: "40%",
          render: (item, row) => (
            <>
              <Row className="leave_a_comment_row">
                <Col span={user === "Associate" ? 22 : 24}>
                  <span>
                    {row?.notes?.associateUser && (
                      <span className="all_item_content all_item_content-sm">
                        {row?.notes?.associateUser &&
                        row?.notes?.associateUser?.length > 50 ? (
                          <>
                            {row?.notes?.associateUser?.substring(0, 120)}
                            {" ..."}
                            <span
                              className="view_more_link cursor_pointer"
                              onClick={() =>
                                user === "Associate"
                                  ? handleEditMessage(row, "associateUser")
                                  : handleViewMore(row, "associateUser")
                              }
                            >
                              View More
                            </span>
                          </>
                        ) : (
                          row?.notes?.associateUser
                        )}
                      </span>
                    )}
                    {!row?.notes?.associateUser && user === "Associate" && (
                      <span className="leave_comment">Leave a comment</span>
                    )}
                    {!row?.notes?.associateUser && user !== "Associate" && (
                      <span className="leave_comment">No comment</span>
                    )}
                  </span>
                </Col>
                {user === "Associate" && (
                  <Col
                    span={1}
                    onClick={() => handleEditMessage(row, "associateUser")}
                  >
                    <img src={editIcon} alt="edit" className="cursor_pointer" />
                  </Col>
                )}
              </Row>
            </>
          ),
        },
      ];
    }
    temp = [
      ...temp,
      {
        title: "",
        dataIndex: "action",
        align: "center",
        width: 100,
        render: (item, rawData) => (
          <Row align={"middle"}>
            <Dropdown
              placement="left"
              overlayClassName="action-dropdown"
              menu={{
                items: extendedActionItems(rawData),
              }}
              trigger={"click"}
            >
              <img
                onClick={(e) => {
                  e.preventDefault();
                  handleDeleteFunctionality(rawData);
                  setCandidateSelectedData(rawData);
                }}
                className="cursor_pointer"
                src={infoIcon}
                alt="edit"
              />
            </Dropdown>
          </Row>
        ),
      },
    ];
    temp = [...temp, {}];
    
    // Filter columns based on visibleColumns
    // If visibleColumns is null, show all columns (default behavior)
    // If visibleColumns is an array, filter based on selection
    if (visibleColumns && Array.isArray(visibleColumns)) {
      temp = temp.filter(col => {
        // Always show Name and Action columns (and empty column at the end)
        if (col.dataIndex === "name" || col.dataIndex === "action" || !col.dataIndex) {
          return true;
        }
        // Show only if column is in visibleColumns
        return visibleColumns.includes(col.dataIndex);
      });
    }
    // If visibleColumns is null, show all columns (no filtering)
    
    setColumns(temp);
    // Also include favoritesList and attachmentMap so columns re-render when favorites or attachments change
  }, [user, favoritesList, visibleColumns, attachmentMap, acceptRejectLoading]);
  // Initialize and update search from location.state
  // Only update if search is explicitly provided in location.state
  // If coming back from applicant profile (no search in state), preserve from sessionStorage
  useEffect(() => {
    // ALWAYS check if search was explicitly cleared first - if so, don't restore anything
    const clearedFlag = sessionStorage.getItem(`searchCleared_${advertId}`) === 'true';
    if (clearedFlag) {
      // If cleared, ensure search is null and don't restore
      if (search !== null && search !== '') {
        setSearch(null);
        handleSearch(null);
      }
      // Don't proceed with any restoration if cleared - return early
      return;
    }
    
    // Skip if location.state is null/undefined
    if (!location?.state) {
      return;
    }
    
    // If coming back from applicant profile and no search in state, preserve from sessionStorage
    if (location.state?.fromTracker && location.state?.search === undefined) {
      // Check cleared flag again before restoring
      const stillCleared = sessionStorage.getItem(`searchCleared_${advertId}`) === 'true';
      if (stillCleared) {
        // If still cleared, don't restore
        if (search !== null && search !== '') {
          setSearch(null);
          handleSearch(null);
        }
        return;
      }
      // Only restore if there's a saved search and current search is empty/null
      // This prevents restoring while user is actively typing
      if (!search || search.trim() === '') {
        const savedSearch = getTrackerStateFromStorage(`trackerSearch_${advertId}`);
        if (savedSearch && typeof savedSearch === 'string' && savedSearch.trim() !== '') {
          setSearch(savedSearch);
          setIsSearchCleared(false); // Reset flag when restoring search
          sessionStorage.removeItem(`searchCleared_${advertId}`);
        }
      }
      return;
    }
    
    // Handle string format ("searchTerm,true")
    if (typeof location?.state === 'string') {
      const splitState = location.state.split(",");
      const searchValue = splitState?.[0] || null;
      const normalizedValue = (searchValue && searchValue.trim() !== '') ? searchValue.trim() : null;
      if (normalizedValue !== null && normalizedValue !== undefined) {
        setSearch(normalizedValue);
        setIsSearchCleared(false); // Reset flag when setting search from location.state
        sessionStorage.removeItem(`searchCleared_${advertId}`);
        // Store in sessionStorage with timestamp
        saveTrackerStateWithTimestamp(`trackerSearch_${advertId}`, normalizedValue);
      } else if (normalizedValue === null && !isSearchCleared) {
        setSearch(null);
        sessionStorage.removeItem(`trackerSearch_${advertId}`);
      }
    } 
    // Handle object format with explicit search property
    else if (location?.state?.search !== undefined) {
      const searchValue = location.state.search;
      const normalizedValue = (searchValue && typeof searchValue === 'string' && searchValue.trim() !== '') ? searchValue.trim() : null;
      if (normalizedValue !== null && normalizedValue !== undefined) {
        setSearch(normalizedValue);
        setIsSearchCleared(false); // Reset flag when setting search from location.state
        sessionStorage.removeItem(`searchCleared_${advertId}`);
        // Store in sessionStorage with timestamp
        saveTrackerStateWithTimestamp(`trackerSearch_${advertId}`, normalizedValue);
      } else if (normalizedValue === null && !isSearchCleared) {
        setSearch(null);
        sessionStorage.removeItem(`trackerSearch_${advertId}`);
      }
    }
  }, [location.state?.search, location.state?.fromTracker, location.state, advertId]);
  
  // Store search in sessionStorage when it changes (with timestamp)
  useEffect(() => {
    // Check cleared flag from sessionStorage (not state) to ensure we respect it
    const clearedFlag = sessionStorage.getItem(`searchCleared_${advertId}`) === 'true';
    
    // If cleared flag is set and search has a value, clear it (prevent restoration)
    if (clearedFlag) {
      if (search !== null && search !== '') {
        setSearch(null);
        setIsSearchCleared(true);
        handleSearch(null);
        sessionStorage.removeItem(`trackerSearch_${advertId}`);
      }
      return; // Don't proceed with storing if cleared
    }
    
    // Only store if search is not empty and not cleared
    if (search && search.trim() !== '' && !isSearchCleared) {
      saveTrackerStateWithTimestamp(`trackerSearch_${advertId}`, search);
    } else {
      sessionStorage.removeItem(`trackerSearch_${advertId}`);
    }
  }, [search, advertId, isSearchCleared]);
  
  // Ensure cleared flag is respected on component mount/render (handles tab switches)
  // This runs whenever advertId changes or on mount to ensure cleared state is maintained
  useEffect(() => {
    const clearedFlag = sessionStorage.getItem(`searchCleared_${advertId}`) === 'true';
    if (clearedFlag) {
      // If cleared flag is set, ensure search is null
      // Only update if search is not already null to avoid unnecessary re-renders
      if (search !== null && search !== '') {
        setSearch(null);
        setIsSearchCleared(true);
        handleSearch(null);
      }
    }
  }, [advertId]); // Only run when advertId changes (on mount or tab switch), not when search changes
  
  // Also check cleared flag whenever search changes to prevent restoration
  useEffect(() => {
    const clearedFlag = sessionStorage.getItem(`searchCleared_${advertId}`) === 'true';
    if (clearedFlag && search !== null && search !== '') {
      // If cleared flag is set but search has a value, clear it immediately
      setSearch(null);
      setIsSearchCleared(true);
      handleSearch(null);
    }
  }, [search, advertId]);
  
  // Handle tab switches - check cleared flag when window regains focus
  useEffect(() => {
    const handleFocus = () => {
      const clearedFlag = sessionStorage.getItem(`searchCleared_${advertId}`) === 'true';
      if (clearedFlag && search !== null && search !== '') {
        // If cleared flag is set but search has a value, clear it
        setSearch(null);
        setIsSearchCleared(true);
        handleSearch(null);
      }
    };
    
    window.addEventListener('focus', handleFocus);
    return () => {
      window.removeEventListener('focus', handleFocus);
    };
  }, [advertId, search]);
  
  // Note: Search and filter are now handled together in the filter effect above
  // This effect is kept for backward compatibility but the main logic is in the filter effect
  
  const handleUpgradeModal = async () => {
    if (JSON.parse(localStorage.getItem("isPlusSubscription"))) {
      try {
        setReportLoading(true);
        try {
          const response = await API_MANAGER.getTrackerReport(advertId);
          downloadPDF(response?.data?.data, "Candidate Report");
          setReportLoading(false);
        } catch (error) {
          setReportLoading(false);
          message.error(
            error?.response?.data?.message ||
              "Something went wrong. Please try again."
          );
        }
      } catch (error) {}
    } else {
      setUpgradeMembership(true);
    }
  };
  const verticleDotItems = [
    {
      key: "2",
      label: (
        <Row className="filter_item_row">
          <Col
            span={24}
            style={{
              color: selectedRowKeys?.length > 0 ? "#1638b1" : "#A7AEBB",
              display: "flex",
              alignItems: "center",
            }}
            onClick={() => {
              if (selectedRowKeys?.length > 0) {
                if (user === "Associate") {
                  handleBulkAcceptRejectCandidate();
                } else {
                  handleStatus();
                }
              }
            }}
          >
            <TableStatusImage
              color={selectedRowKeys?.length > 0 ? "#1638b1" : "#A7AEBB"}
            />
            &nbsp; {user === "Associate" ? "Accept" : "Status"}
          </Col>
        </Row>
      ),
    },
    {
      key: "3",
      label: (
        <Row className="filter_item_row">
          <Col
            span={24}
            onClick={handleUpgradeModal}
            style={{
              color: JSON.parse(localStorage.getItem("isPlusSubscription"))
                ? "#1638B1"
                : "#A7AEBB",
              display: "flex",
              alignItems: "center",
            }}
          >
            <DownloadIcon
              color={
                JSON.parse(localStorage.getItem("isPlusSubscription"))
                  ? "#1638B1"
                  : "#a7aebb"
              }
            />{" "}
            &nbsp; {reportLoading ? "Downloading..." : "Download"}
          </Col>
        </Row>
      ),
    },
  ];
  const categoryItems = [
    {
      key: "1",
      label: (
        <Row>
          <span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="4"
              height="22"
              viewBox="0 0 4 22"
              fill="none"
            >
              <rect width="4" height="22" rx="2" fill="#8BD053" />
            </svg>
          </span>
          &nbsp; Meets must-have
        </Row>
      ),
    },
    {
      key: "2",
      label: (
        <Row>
          <span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="4"
              height="22"
              viewBox="0 0 4 22"
              fill="none"
            >
              <rect width="4" height="22" rx="2" fill="#F8C239" />
            </svg>
          </span>
          &nbsp; Partially meets must-have
        </Row>
      ),
    },
    {
      key: "3",
      label: (
        <Row align={"middle"}>
          <span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="4"
              height="22"
              viewBox="0 0 4 22"
              fill="none"
            >
              <rect width="4" height="22" rx="2" fill="#F95C46" />
            </svg>
          </span>
          &nbsp; Doesn’t meet must-have
        </Row>
      ),
    },
  ];
  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
    setRowKey(newSelectedRowKeys);
    const temp = data2?.users?.filter((e) => {
      if (newSelectedRowKeys.includes(e?.appliedJob)) {
        return e;
      } else {
        return null;
      }
    });
    setSelectedRowData(temp);
  };
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };
  const handleSearch = (e) => {
    // Search is now handled by useMemo, so we don't need to setData here
    // The search state change will trigger useMemo to recalculate
  };

  const handleSelect = (filters) => {
    // Handle clear action - when allowClear is clicked, filters will be null, undefined, or empty array
    if (filters === null || filters === undefined || (Array.isArray(filters) && filters.length === 0)) {
      sessionStorage.removeItem(`trackerFilter_${advertId}_NOTES`);
      setFilterType([]);
      return;
    }
    
    // Filter out blank/empty values
    const filterBlankValues = (arr) => {
      if (Array.isArray(arr)) {
        return arr.filter(f => {
          if (!f) return false;
          if (typeof f === 'string') return f.trim() !== '';
          return true;
        });
      }
      return [];
    };
    
    // Normalize filters - ensure it's an array and filter out blank values
    const normalizedFilters = Array.isArray(filters) ? filters : (filters ? [filters] : []);
    const filtered = filterBlankValues(normalizedFilters);
    
    if (filtered.length > 0) {
      saveTrackerStateWithTimestamp(`trackerFilter_${advertId}_NOTES`, filtered);
      setFilterType(filtered);
    } else {
      sessionStorage.removeItem(`trackerFilter_${advertId}_NOTES`);
      setFilterType([]);
    }
  };

  // Extended action items with Accept and Forward
  const extendedActionItems = (rawData) => {
    const baseItems = tableActionItems ? tableActionItems(rawData) : [];
    
    // Build action items in the correct order to match AdvertDetail.js
    // Order: Status, Remove, Transfer, Forward candidate, Unrelease, Report, Unaccept
    if (userType !== "Associate") {
      return [
        {
          key: "actions",
          label: (
            <div className="action-dropdown">
              {/* Status */}
              <Row>
                <Col
                  onClick={() => {
                    setSelectedRowData([rawData]);
                    setRowKey([rawData?.appliedJob]);
                    handleStatus();
                  }}
                  className="item"
                  span={24}
                >
                  <img src={status_image} alt="Status" />
                  <span>Status</span>
                </Col>
              </Row>
              {/* Remove */}
              <Row>
                <Col
                  onClick={() => handleDelete([rawData?.appliedJob])}
                  className="item"
                  span={24}
                >
                  <img src={action_delete} alt="Remove" />
                  <span>Remove</span>
                </Col>
              </Row>
              {/* Transfer */}
              <Row>
                <Col
                  onClick={() => {
                    setCandidateSelectedData(rawData); // Set candidate data for TransferModal
                    handleDeleteFunctionality(rawData);
                    if (setTransferModal) {
                      setTransferModal(true);
                    }
                  }}
                  className="item"
                  span={24}
                >
                  <img src={transeferImage} alt="Transfer" />
                  <span>Transfer</span>
                </Col>
              </Row>
              {/* Forward candidate */}
              <Row>
                <Col
                  onClick={() => {
                    setCandidateForForward(rawData);
                    setTransferUserModal(true);
                  }}
                  className="item"
                  span={24}
                >
                  <img src={shareIcon} alt="Forward" />
                  <span>Forward candidate</span>
                </Col>
              </Row>
              {/* Release / Unrelease */}
              {rawData?.isReleased ? (
                <Row>
                  <Col
                    onClick={() => {
                      const data = {
                        value: false,
                        applicationIds: [rawData?.appliedJob],
                      };
                      API_MANAGER.bulkRelease(data).then(() => {
                        message.success("Application successfully unreleased.");
                        getData();
                      }).catch(() => {
                        message.error("Something went wrong. Please try again.");
                      });
                    }}
                    className="item"
                    span={24}
                  >
                    <img
                      src={rocketIcon}
                      height={15}
                      width={15}
                      style={{ rotate: "180deg" }}
                      alt="Unrelease"
                    />
                    <span>Unrelease</span>
                  </Col>
                </Row>
              ) : (
                <Row>
                  <Col
                    onClick={() => {
                      const data = {
                        value: true,
                        applicationIds: [rawData?.appliedJob],
                      };
                      API_MANAGER.bulkRelease(data).then(() => {
                        message.success("Application successfully released.");
                        getData();
                      }).catch(() => {
                        message.error("Something went wrong. Please try again.");
                      });
                    }}
                    className="item"
                    span={24}
                  >
                    <img
                      src={rocketIcon}
                      height={15}
                      width={15}
                      alt="Release"
                    />
                    <span>Release</span>
                  </Col>
                </Row>
              )}
              {/* Report */}
              <Row>
                <Col
                  onClick={() => {
                    setReportCandidateData({ candidateName: rawData?.profileId?.name });
                    setReportModal(true);
                  }}
                  className="item"
                  span={24}
                >
                  <img src={alert_triangle} />
                  <span>Report</span>
                </Col>
              </Row>
              {/* Unaccept/Accept */}
              <Row>
                <Col
                  onClick={() => handleAcceptReject("accept", rawData)}
                  className={`item ${acceptRejectLoading ? "disabled" : ""}`}
                  span={24}
                  style={{ cursor: acceptRejectLoading ? "not-allowed" : "pointer" }}
                >
                  <img src="/unaccept.svg" alt="Accept/Unaccept" />
                  <span>
                    {acceptRejectLoading ? "Processing..." : (rawData?.isApproved == "accepted" ? "Unaccept" : "Accept")}
                  </span>
                </Col>
              </Row>
            </div>
          ),
        },
      ];
    } else {
      // For Associate users, show Accept/Unaccept and Reject/Unreject
      return [
        {
          key: "actions",
          label: (
            <div className="action-dropdown">
              <Row>
                <Col
                  onClick={() => handleAcceptReject("accept", rawData)}
                  className={`item ${acceptRejectLoading ? "disabled" : ""}`}
                  span={24}
                  style={{ cursor: acceptRejectLoading ? "not-allowed" : "pointer" }}
                >
                  <img src="/unaccept.svg" alt="Accept/Unaccept" />
                  <span>
                    {acceptRejectLoading ? "Processing..." : (rawData?.isApproved == "accepted" ? "Unaccept" : "Accept")}
                  </span>
                </Col>
              </Row>
              <Row>
                <Col
                  onClick={() => handleAcceptReject("reject", rawData)}
                  className={`item ${acceptRejectLoading ? "disabled" : ""}`}
                  span={24}
                  style={{ cursor: acceptRejectLoading ? "not-allowed" : "pointer" }}
                >
                  <img src={action_delete} alt="Reject/Unreject" />
                  <span>
                    {acceptRejectLoading ? "Processing..." : (rawData?.isApproved == "rejected" ? "Unreject" : "Reject")}
                  </span>
                </Col>
              </Row>
              {/* Forward candidate */}
              <Row>
                <Col
                  onClick={() => {
                    setCandidateForForward(rawData);
                    setTransferUserModal(true);
                  }}
                  className="item"
                  span={24}
                >
                  <img src={shareIcon} alt="Forward" />
                  <span>Forward candidate</span>
                </Col>
              </Row>
            </div>
          ),
        },
      ];
    }
  };
  
  return (
    <div>
      <UpgradeMembershipModal
        setUpgradeMembership={setUpgradeMembership}
        upgradeMembership={upgradeMembership}
      />
      <Reportpopup
        data={reportCandidateData || { candidateName: "" }}
        reportModal={reportModal}
        setReportModal={setReportModal}
      />
      <ProfileDrawer
        open={openProfileDrawer}
        setOpen={setOpenProfileDrawer}
        data={profileDrawerData}
        advertId={advertId}
        currentPage={currentPage}
        search={search}
        filterType={filterType}
        tabType={sessionStorage.getItem(`trackerTabType_${advertId}`) || "NOTES"}
        locationState={location.state}
      />
      <EditAddMessageModal
        messageModal={messageModal}
        setMessageModal={setMessageModal}
        buttonVisible={buttonVisible}
        selectedMessage={selectedMessage}
        onSaved={(appliedJob, notes) => {
          const nextUsers = (data2UsersRef.current || []).map((row) =>
            String(row?.appliedJob) === String(appliedJob)
              ? { ...row, notes: { ...(row.notes || {}), ...notes } }
              : row
          );
          data2UsersRef.current = nextUsers;
          previousData2UsersRef.current = nextUsers;
          setDataVersion((version) => version + 1);
          onNotesSaved?.(appliedJob, notes);
        }}
      />
      <div className="hard_requirement_container">
        <div className="progressBox_container mt-24">
          <Row gutter={4}>
            <Col xs={0} md={8}>
              <span className="progress-text">{`Fully meets`}</span>
              {/* <span className="progress-text-bold">{`(${fullyMeets})`}</span> */}
              <div className="progressBox success_box"></div>
            </Col>
            <Col xs={0} md={8}>
              <span className="progress-text">{`Partially meets`}</span>
              {/* <span className="progress-text-bold">{`(${partiallyMeets})`}</span> */}
              <div className="progressBox partial_box"></div>
            </Col>
            <Col xs={0} md={8}>
              <span className="progress-text">{`Doesn’t meet`}</span>
              {/* <span className="progress-text-bold">{`(${doesNotMeets})`}</span> */}
              <div className=" progressBox red_box"></div>
            </Col>
            {/* ************ for sm only ************* */}
            <Col xs={8} md={0}>
              <span className="progress-text">{`Fully meets`}</span>
              {/* <span className="progress-text-bold">{`(3)`}</span> */}
              <div className="progressBox success_box"></div>
            </Col>
            <Col xs={8} md={0}>
              <span className="progress-text">{`Partially meets`}</span>
              {/* <span className="progress-text-bold">{`(3)`}</span> */}
              <div className="progressBox partial_box"></div>
            </Col>
            <Col xs={8} md={0}>
              <span className="progress-text">{`Doesn’t meet`}</span>
              {/* <span className="progress-text-bold">{`(4)`}</span> */}
              <div className=" progressBox red_box"></div>
            </Col>
          </Row>
        </div>
        <div className="mt-24 tableContainer">
          <div className="advert_table_box">
            <Table
              rowSelection={rowSelection}
              columns={columns}
              dataSource={paginatedData}
              className="soft_requirement_table"
              pagination={false}
              scroll={{ x: "calc(750px + 60%)" }}
              rowKey={"appliedJob"}
              title={() => (
                <Row justify={"space-between"} className="align_items_center">
                  <Col xs={0} md={10}>
                    {user !== "Associate" && (
                      <Row gutter={{ md: 16, lg: 32 }} justify={"start"}>
                        <Col style={{ marginRight: "12px" }}>
                          <Tooltip title="Remove">
                            <Row
                              className="cursor-pointer"
                              gutter={6}
                              align={"middle"}
                              onClick={() => {
                                if (selectedRowKeys?.length > 0) {
                                  handleDelete(selectedRowKeys);
                                }
                              }}
                            >
                              <Col>
                                <CommonDeleteSvg
                                  color={
                                    selectedRowKeys?.length > 0
                                      ? "#d03c28"
                                      : "#A7AEBB"
                                  }
                                />
                              </Col>
                            </Row>
                          </Tooltip>
                        </Col>
                        <Col style={{ marginRight: "12px" }}>
                          <Tooltip title="Status">
                            <Row
                              gutter={6}
                              align={"middle"}
                              style={{ marginTop: "4px" }}
                              className="cursor-pointer"
                              onClick={() => {
                                if (selectedRowKeys?.length > 0) {
                                  if (user === "Associate") {
                                    handleBulkAcceptRejectCandidate();
                                  } else {
                                    handleStatus();
                                  }
                                }
                              }}
                            >
                              <Col>
                                <TableStatusImage
                                  color={
                                    selectedRowKeys?.length > 0
                                      ? "#1638b1"
                                      : "#A7AEBB"
                                  }
                                />
                              </Col>
                            </Row>
                          </Tooltip>
                        </Col>
                        <Col style={{ marginRight: "12px" }}>
                          <Tooltip title="Generate Candidate Report">
                            <Row>
                              <Col
                                xs={24}
                                onClick={handleUpgradeModal}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "4px",
                                  cursor: "pointer",
                                }}
                              >
                                <DownloadIcon
                                  color={
                                    JSON.parse(
                                      localStorage.getItem("isPlusSubscription")
                                    )
                                      ? "#1638B1"
                                      : "#a7aebb"
                                  }
                                />
                                {/* <img src={downloadIcon} /> &nbsp; */}
                              </Col>
                            </Row>
                          </Tooltip>
                        </Col>
                        <Col
                          className="candidate_report_col cursor_pointer"
                          style={{ marginRight: "12px" }}
                          onClick={ehHrReport}
                        >
                          <Tooltip title="Export">
                            <Row align={"middle"} gutter={4}>
                              <Col>
                                <img src={exportImage} />
                              </Col>
                            </Row>
                          </Tooltip>
                        </Col>
                        {user !== "Associate" && (
                          <Col
                            className="candidate_report_col cursor_pointer"
                            style={{ marginRight: "12px" }}
                            onClick={handleReleaseClick}
                          >
                            <Row align="middle" gutter={4}>
                              <Col>
                                <Tooltip title="Share with 3rd party platforms">
                                  <img
                                    src={externalRocket}
                                    height={26}
                                    width={40}
                                  />
                                </Tooltip>
                              </Col>
                            </Row>
                          </Col>
                        )}
                        {user !== "Associate" && (
                          <Col
                            // span={11}
                            className="candidate_report_col cursor_pointer"
                            style={{ marginRight: "12px" }}
                            // onClick={() => handleUpdagradeMembership()}

                            onClick={
                              selectedRowKeys?.length > 0 ? handelAssign : null
                            }
                          >
                            <Row align={"middle"} gutter={4}>
                              <Col>
                                <Tooltip title="Release to client">
                                  <img
                                    src={rocketIcon}
                                    style={{
                                      opacity: hasSelected ? 1 : 0.4,
                                      cursor: hasSelected
                                        ? "pointer"
                                        : "not-allowed",
                                    }}
                                  />
                                </Tooltip>
                              </Col>
                            </Row>
                          </Col>
                        )}
                        {user !== "Associate" && (
                          <WorkforceRequestButton
                            advertId={advertId}
                            selectedIds={selectedRowKeys}
                            candidates={data2?.users || []}
                            onSuccess={getData}
                          />
                        )}
                      </Row>
                    )}
                    {user === "Associate" && (
                      <Row gutter={{ md: 16, lg: 32 }} justify={"start"}>
                        <Col>
                          <Row
                            gutter={6}
                            align={"middle"}
                            className="cursor-pointer"
                            onClick={() => {
                              if (selectedRowKeys?.length > 0) {
                                handleBulkAcceptRejectCandidate();
                              }
                            }}
                          >
                            <Col>
                              <TableStatusImage
                                color={
                                  selectedRowKeys?.length > 0
                                    ? "#1638B1"
                                    : "#A7AEBB"
                                }
                              />
                            </Col>
                            <Col
                              className="delete"
                              style={{
                                color:
                                  selectedRowKeys?.length > 0
                                    ? "#1638b1"
                                    : "#A7AEBB",
                              }}
                            >
                              Accept
                            </Col>
                          </Row>
                        </Col>
                        <Col>
                          <Row>
                            <Col
                              xs={24}
                              onClick={handleUpgradeModal}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "4px",
                                cursor: "pointer",
                              }}
                            >
                              <DownloadIcon
                                color={
                                  JSON.parse(
                                    localStorage.getItem("isPlusSubscription")
                                  )
                                    ? "#1638B1"
                                    : "#a7aebb"
                                }
                              />{" "}
                              {/* <img src={downloadIcon} /> &nbsp; */}
                              <span
                                className={
                                  JSON.parse(
                                    localStorage.getItem("isPlusSubscription")
                                  )
                                    ? "activeLink"
                                    : "deactiveLink"
                                }
                              >
                                {reportLoading
                                  ? "Downloading..."
                                  : "Candidate Report"}
                              </span>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    )}
                  </Col>
                  <Col xs={0} md={14}>
                    <Row gutter={16} align={"middle"}>
                      <Col span={10}>
                        <Input.Search
                          className="searchBox w-100"
                          placeholder="Search candidate name"
                          value={search || ''}
                          onChange={(e) => {
                            const newValue = e?.target?.value || null;
                            const trimmedValue = newValue?.trim() || '';
                            
                            if (!newValue || trimmedValue === "") {
                              setIsSearchCleared(true);
                              sessionStorage.setItem(
                                `searchCleared_${advertId}`,
                                "true"
                              );
                              sessionStorage.removeItem(
                                `trackerSearch_${advertId}`
                              );
                              setSearch(null);
                              handleSearch(null);
                            } else {
                              if (!search) {
                                pageBeforeSearchRef.current = currentPage;
                              }
                              setIsSearchCleared(false);
                              sessionStorage.removeItem(
                                `searchCleared_${advertId}`
                              );
                              setSearch(newValue);
                              handleSearch(newValue);
                              sessionStorage.setItem(`trackerSearch_${advertId}`, newValue);
                            }
                          }}
                          suffix={
                            search && (
                              <img
                                src={CancelIcon}
                                className="cursor_pointer"
                                alt="cross"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  e.preventDefault();
                                  setSearch(null);
                                  setIsSearchCleared(true);
                                  sessionStorage.setItem(
                                    `searchCleared_${advertId}`,
                                    "true"
                                  );
                                  sessionStorage.removeItem(
                                    `trackerSearch_${advertId}`
                                  );
                                  handleSearch(null);
                                }}
                              />
                            )
                          }
                          prefix={<img src={SearchIcon} alt="search" />}
                        />
                      </Col>
                      <Col span={8}>
                        <Select
                          placeholder="Select category"
                          optionLabelProp="label"
                          className="w-100 selectBox"
                          value={filterType && filterType.length > 0 ? filterType : undefined}
                          onChange={(e) => {
                            handleSelect(e);
                          }}
                          maxTagCount={1}
                          mode="multiple"
                          allowClear
                        >
                          <Select.Option
                            className="multiselect_items_col"
                            value="Yes"
                            label=" Meets must-have"
                          >
                            <Row gutter={8}>
                              <Col>
                                <div className="verticalBox"></div>
                              </Col>
                              <Col>
                                <Checkbox
                                  checked={
                                    filterType.includes("Yes") ? true : false
                                  }
                                />
                              </Col>
                              <Col>Fully meets</Col>
                            </Row>
                          </Select.Option>
                          <Select.Option
                            className="multiselect_items_col"
                            value="Warning"
                            label="Partially meets must-have"
                          >
                            <Row gutter={8}>
                              <Col>
                                <div className="verticalBox yellowVerticalBox "></div>
                              </Col>
                              <Col>
                                <Checkbox
                                  checked={
                                    filterType.includes("Warning")
                                      ? true
                                      : false
                                  }
                                />
                              </Col>
                              <Col> Partially meets</Col>
                            </Row>
                          </Select.Option>
                          <Select.Option
                            className="multiselect_items_col"
                            label="Doesn't meet must-have"
                            value="No"
                          >
                            <Row gutter={8}>
                              <Col>
                                <div className="verticalBox redVerticalBox"></div>
                              </Col>
                              <Col>
                                <Checkbox
                                  checked={
                                    filterType.includes("No") ? true : false
                                  }
                                />
                              </Col>
                              <Col>Doesn't meet</Col>
                            </Row>
                          </Select.Option>
                        </Select>
                      </Col>
                     
                    </Row>
                  </Col>
                  {/* for small screen only */}
                  <Col md={0} xs={21}>
                    <Input.Search
                      className="searchBox w-100"
                      placeholder="Search candidate name"
                      prefix={
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="18"
                          viewBox="0 0 18 18"
                          fill="none"
                        >
                          <path
                            d="M17 17L13.1396 13.1396M13.1396 13.1396C13.7999 12.4793 14.3237 11.6953 14.6811 10.8326C15.0385 9.96978 15.2224 9.04507 15.2224 8.11121C15.2224 7.17735 15.0385 6.25264 14.6811 5.38987C14.3237 4.5271 13.7999 3.74316 13.1396 3.08283C12.4793 2.42249 11.6953 1.89868 10.8326 1.54131C9.96978 1.18394 9.04507 1 8.11121 1C7.17735 1 6.25264 1.18394 5.38987 1.54131C4.5271 1.89868 3.74316 2.42249 3.08283 3.08283C1.74921 4.41644 1 6.2252 1 8.11121C1 9.99722 1.74921 11.806 3.08283 13.1396C4.41644 14.4732 6.2252 15.2224 8.11121 15.2224C9.99722 15.2224 11.806 14.4732 13.1396 13.1396Z"
                            stroke="#1638B1"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      }
                      // ****************testing***************//
                      suffix={
                        <Dropdown
                          menu={{
                            items: categoryItems,
                          }}
                          placement="bottomLeft"
                          trigger={["click"]}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <path
                              d="M3 8L15 8M15 8C15 9.65686 16.3431 11 18 11C19.6569 11 21 9.65685 21 8C21 6.34315 19.6569 5 18 5C16.3431 5 15 6.34315 15 8ZM9 16L21 16M9 16C9 17.6569 7.65685 19 6 19C4.34315 19 3 17.6569 3 16C3 14.3431 4.34315 13 6 13C7.65685 13 9 14.3431 9 16Z"
                              stroke="#CDD2DC"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </Dropdown>
                      }
                    />
                  </Col>
                  <Col md={0} xs={2}>
                    {/* dropdown for verticle dot */}
                    <Dropdown
                      menu={{
                        items:
                          user === "Associate"
                            ? verticleDotItems
                            : [
                                ...verticleDotItems,
                                {
                                  key: "1",
                                  label: (
                                    <Row
                                      className="filter_item_row"
                                      onClick={() => {
                                        if (selectedRowKeys?.length > 0) {
                                          handleDelete(selectedRowKeys);
                                        }
                                      }}
                                    >
                                      <Col
                                        span={24}
                                        style={{
                                          color:
                                            selectedRowKeys?.length > 0
                                              ? "#d03c28"
                                              : "#A7AEBB",
                                          display: "flex",
                                          alignItems: "center",
                                        }}
                                      >
                                        <CommonDeleteSvg
                                          color={
                                            selectedRowKeys?.length > 0
                                              ? "#d03c28"
                                              : "#A7AEBB"
                                          }
                                        />{" "}
                                        &nbsp; Delete
                                      </Col>
                                    </Row>
                                  ),
                                },
                              ],
                      }}
                      overlayClassName="notificationFilterDropdown"
                      placement="bottomLeft"
                      trigger={["click"]}
                    >
                      <img
                        src={verticleDot}
                        alt="vertical dots"
                        className="vertical-dot"
                      />
                    </Dropdown>
                  </Col>
                </Row>
              )}
              rowClassName={(row) =>
                row?.overAllStatus === "Yes"
                  ? "successRow"
                  : row?.overAllStatus === "Warning"
                  ? "warningRow"
                  : "closeRow"
              }
            />
            <ReleaseModal
              visible={releaseModal}
              setVisible={setreleaseModal}
              text={"release"}
              handleSubmitAssign={bulkassign}
              loading={deleteLoading}
            />
            <ReleaseToExternalClientModal
              visible={modalVisible}
              onClose={handleModalClose}
              onNext={handleNextStep}
              candidateDetails={data2?.users}
            />
            <Modal
              className="candidateDeleteModal"
              centered
              getContainer={document.body}
              title={pendingAcceptData?.isApproved === "rejected" ? "Upload Proof Document for Rejection" : "Upload Proof Document"}
              open={proofUploadModal}
              onCancel={() => {
                setProofUploadModal(false);
                setProofFile(null);
                setPendingAcceptData(null);
              }}
              footer={null}
            >
              <Row className="header">
                <Col span={24} >
                  <Upload
                    beforeUpload={() => false}
                    onChange={handleProofFileChange}
                    fileList={proofFile ? [{
                      uid: '-1',
                      name: proofFile.name,
                      status: 'done',
                      originFileObj: proofFile,
                    }] : []}
                    maxCount={1}
                    accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                    onRemove={() => {
                      setProofFile(null);
                      return true;
                    }}
                  >
                    <Button style={{marginBottom:"10px"}}>Select File</Button>
                  </Upload>
                  <p className="desc" style={{ marginTop: "10px", marginBottom: 0 }}>
                    Please upload a proof document (PDF, DOC, DOCX, JPG, JPEG, or PNG)
                  </p>
                </Col>
              </Row>
              <Row align={"middle"} gutter={16} justify={"end"}>
                <Col>
                  <Button
                    className="cancelBtn"
                    onClick={() => {
                      setProofUploadModal(false);
                      setProofFile(null);
                      setPendingAcceptData(null);
                    }}
                  >
                    Cancel
                  </Button>
                </Col>
                <Col>
                  <Button
                    className="confirmBtn"
                    loading={uploadingProof}
                    onClick={handleProofUpload}
                  >
                    {pendingAcceptData?.isApproved === "rejected" ? "Upload & Reject" : "Upload & Accept"}
                  </Button>
                </Col>
              </Row>
            </Modal>
            <TransferUserModal
              isModalOpen={transferUserModal}
              handleCancel={() => {
                setTransferUserModal(false);
                setCandidateForForward(null);
              }}
              candidateSelectedData={candidateForForward}
              handleOk={async (data) => {
                try {
                  // Fetch advert details to get the application _id
                  const advertResponse = await API_MANAGER.getAdvertDetail(advertId);
                  const advertData = advertResponse?.data?.data;
                  const applications = advertData?.applications || [];
                  
                  // Find the matching application using appliedJob ID
                  const appliedJobId = candidateForForward?.appliedJob;
                  const matchingApplication = applications.find(app => app._id === appliedJobId || app.id === appliedJobId);
                  
                  // Use the application _id as candidateId, fallback to appliedJob if not found
                  const candidateId = matchingApplication?._id || matchingApplication?.id || appliedJobId;
                  
                  if (!candidateId) {
                    message.error("Candidate ID not found.");
                    return;
                  }

                  const payload = {
                    candidateId: candidateId,
                    recipientUserIds: data.recipientUserIds || [],
                    recipientEmails: data.recipientEmails || [],
                  };

                  if (payload.recipientUserIds.length === 0 && payload.recipientEmails.length === 0) {
                    message.warning("Please select at least one user or add an email.");
                    return;
                  }

                  const response = await API_MANAGER.forwardProfile(payload);
                  message.success("Profile successfully forwarded.");
                  setTransferUserModal(false);
                  setCandidateForForward(null);
                  getData();
                } catch (error) {
                  message.error(
                    error?.response?.data?.message ||
                      "Failed to forward profile. Please try again."
                  );
                }
              }}
            />
            <CustomPagination
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              total={data?.length || 0}
              itemPerPage={dataperpage}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Notes;
